import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { formatDateWithTime } from "../../../../shared/utility";
import DeveloperBarcode from "../../../controls/DeveloperBarcode";

export default function WipOutgoingSubTable2(props) {
  const { data, outgoingSubLoadingRows, outgoingSubRowDetails } = props;

  if (outgoingSubLoadingRows[data.unique_id]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const detail = outgoingSubRowDetails[data.unique_id];
  if (!detail) return null;

  const bodyItemProductName = (item) => {
    return (
      <div>
        {item.product_name} <br />{" "}
        <span className="font-bold">PLU: {item.plu}</span>
      </div>
    );
  };

  const bodyItemWeight = (item) => {
    return <p>{item.produced_net_kg} kg</p>;
  };

  const bodyItemPieces = (item) => {
    return <p>{item.produced_piece_count} pieces</p>;
  };

  const bodyFormatCreatedDate = (item) => {
    return <p>{formatDateWithTime(item.created_date)}</p>;
  };

  const itemCostInDollars = (item) => {
    return <p>${item.production_total_cost}</p>;
  };

  function barcodeLastNineDigits(rowData) {
    return (
      <div>
        <p>{rowData.barcode.slice(-14)}</p>
        <DeveloperBarcode value={rowData.barcode} compact />
      </div>
    );
  }

  return (
    <div>
      <DataTable
        value={outgoingSubRowDetails[data.unique_id]}
        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm wip-incoming-sub-items-table"
        cellClassName="py-2 border-1-bottom-gray px-2 text-sm"
      >
        <Column
          header="Product Name"
          body={bodyItemProductName}
          style={{ width: "23%" }}
        />
        <Column
          field="lot_number"
          header="Lot Number"
          style={{ width: "10%" }}
        />
        <Column
          body={barcodeLastNineDigits}
          header="Barcode"
          style={{ width: "20%" }}
        />
        <Column
          field="created_by_name"
          header="Created by"
          style={{ width: "8%" }}
        />
        <Column
          header="Date added"
          body={bodyFormatCreatedDate}
          style={{ width: "12%" }}
        />
        <Column
          header="Total Weight"
          body={bodyItemWeight}
          style={{ width: "7%" }}
        />
        <Column
          header="Total Pieces"
          body={bodyItemPieces}
          style={{ width: "7%" }}
        />
        <Column header="Cost $" body={itemCostInDollars} />
      </DataTable>
    </div>
  );
}
